module.exports = __webpack_public_path__ + "img/logo.e909020e.png";